import { render, staticRenderFns } from "./_updateMapping.vue?vue&type=template&id=04c36f8e&lang=pug&"
import script from "./_updateMapping.vue?vue&type=script&lang=js&"
export * from "./_updateMapping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports